// ── AllPmtPostingRulesPage (wfloanmatchrules) — admin only ──
import { useState, useEffect } from "react";
import { B } from "../../../shared/theme";
import { fmtDate } from "../../../shared/format";
import { Btn, Card, FInput, Icon, STh, SectionHeader, Td, TdNum, Th } from "../../../shared/ui";
import { useApp } from "../../../shared/appContext";

export const AllPmtPostingRulesPage = () => {
  const { api, role, setModal, setConfirm, delRec } = useApp();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [sortKey, setSortKey] = useState("priority");
  const [sortDir, setSortDir] = useState("asc");

  const load = async () => {
    setLoading(true);
    try { setRows(await api.get("getPmtPostingRules")); } catch (e) {}
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const toggle = key => {
    if (sortKey === key) setSortDir(d => d === "asc" ? "desc" : "asc");
    else { setSortKey(key); setSortDir("asc"); }
  };

  const displayed = rows
    .filter(r => {
      const q = search.toLowerCase();
      return !q || (r.pattern || "").toLowerCase().includes(q)
        || String(r.loanid || "").toLowerCase().includes(q)
        || (r.notes || "").toLowerCase().includes(q);
    })
    .sort((a, b) => {
      let av = a[sortKey] ?? "", bv = b[sortKey] ?? "";
      if (typeof av === "number" || typeof bv === "number") return sortDir === "asc" ? (av - bv) : (bv - av);
      return sortDir === "asc" ? String(av).localeCompare(String(bv)) : String(bv).localeCompare(String(av));
    });

  const ActivePill = ({ on }) => (
    <span style={{ display: "inline-block", padding: "2px 8px", borderRadius: 4, fontSize: 12, fontWeight: 600, background: on ? "#E1F5EE" : "#F2F2F2", color: on ? "#0F6E56" : "#888" }}>
      {on ? "Active" : "Inactive"}
    </span>
  );

  return <>
    <SectionHeader title="Payment Posting Mapping" />

    <Card style={{ marginBottom: 16, padding: 16 }}>
      <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
        <FInput placeholder="Search pattern, loan, notes..." value={search} onChange={setSearch} />
        <div style={{ flex: 1 }} />
        {role.canEdit && <Btn variant="primary" onClick={() => setModal({ type: "pmtpostingrule-add", onDone: load })}>+ Add Rule</Btn>}
      </div>
    </Card>

    <Card style={{ overflowX: "auto" }}>
      {loading
        ? <div style={{ padding: 32, textAlign: "center", color: "var(--color-text-secondary)" }}>Loading...</div>
        : <table style={{ width: "100%", borderCollapse: "collapse", whiteSpace: "nowrap" }}>
          <thead><tr>
            <STh label="Priority" sortKey="priority" currentKey={sortKey} currentDir={sortDir} onSort={toggle} numeric />
            <STh label="Pattern" sortKey="pattern" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
            <STh label="Loan ID" sortKey="loanid" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
            <STh label="Active" sortKey="isactive" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
            <STh label="Notes" sortKey="notes" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
            <STh label="Created" sortKey="createddate" currentKey={sortKey} currentDir={sortDir} onSort={toggle} />
            <Th></Th>
          </tr></thead>
          <tbody>
            {displayed.map(r => (
              <tr key={r.id} style={{ cursor: "pointer" }}
                onClick={() => setModal({ type: "pmtpostingrule-view", rec: r })}
                onMouseEnter={e => e.currentTarget.style.background = "var(--color-background-secondary)"}
                onMouseLeave={e => e.currentTarget.style.background = ""}>
                <TdNum style={{ fontWeight: 500 }}>{r.priority ?? "—"}</TdNum>
                <Td><span style={{ fontFamily: "var(--font-mono)", fontSize: 12 }}>{r.pattern || "—"}</span></Td>
                <Td><span style={{ fontFamily: "var(--font-mono)", fontSize: 12 }}>{r.loanid || "—"}</span></Td>
                <Td><ActivePill on={r.isactive === true || r.isactive === 1} /></Td>
                <Td style={{ color: "var(--color-text-secondary)", fontSize: 12, maxWidth: 300, overflow: "hidden", textOverflow: "ellipsis" }}>{r.notes || "—"}</Td>
                <Td><span style={{ fontFamily: "var(--font-mono)", fontSize: 12 }}>{fmtDate(r.createddate)}</span></Td>
                <Td>
                  <Btn onClick={e => { e.stopPropagation(); setModal({ type: "pmtpostingrule-view", rec: r }); }}><Icon type="view" /></Btn>
                  {role.canEdit && <Btn onClick={e => { e.stopPropagation(); setModal({ type: "pmtpostingrule-edit", rec: r, onDone: load }); }}><Icon type="edit" /></Btn>}
                  {role.canDelete && <Btn variant="danger" onClick={e => { e.stopPropagation(); setConfirm({ msg: "Delete this posting rule?", onConfirm: async () => { await delRec("wfloanmatchrules", r.id, "Deleted payment posting rule", load); setConfirm(null); } }); }}><Icon type="delete" /></Btn>}
                </Td>
              </tr>
            ))}
            {!displayed.length && (
              <tr><td colSpan={7} style={{ textAlign: "center", padding: 32, color: "var(--color-text-secondary)", fontSize: 13 }}>No posting rules found.</td></tr>
            )}
          </tbody>
        </table>}
    </Card>
  </>;
};
